import { UtilService } from 'src/app/core/services/util/util.service';
import { Subscription } from 'rxjs';

import { ErrorHandler, Injectable, Injector, OnDestroy, inject } from '@angular/core';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Router } from '@angular/router';

import { ErrorsService } from '../errors-service/errors.service';
import { NotificationService } from '../../services/notification/notification.service';
import { AppGlobalsModule } from 'src/app/app-globals.module';
import { RESPONSE } from 'src/express.tokens';
import { BrowserPlatformService } from '../../services/browser-platform/browser-platform.service';

@Injectable({
    providedIn: 'root',
})
export class ErrorsHandler implements ErrorHandler, OnDestroy {
    private injector = inject(Injector);
    private _utils = inject(UtilService);
    private response = inject(RESPONSE, { optional: true })!;
    private _browser = inject(BrowserPlatformService);

    private _global = AppGlobalsModule;
    private _subscriptions: Subscription[] = [];

    handleCriticalError(error: Error | HttpErrorResponse) {
        this.handleError(error);
    }

    handleError(error: Error | HttpErrorResponse) {
        // The global rate-limit interceptor owns 429 navigation. Do not report it as an application failure.
        if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.TooManyRequests) {
            return;
        }

        // In staging universal we need to return error code 500 so tests would fail.
        if (AppGlobalsModule.isServer && this._utils.isStaging()) {
            this.response?.status(500);
        }

        const notificationService = this.injector.get(NotificationService);
        const errorsService = this.injector.get(ErrorsService);

        if (error instanceof HttpErrorResponse) {
            // Server error happeneds
            if (!this._global.isServer && !this._browser.isOnline) {
                // No Internet connection
                return notificationService.notify('No Internet Connection');
            }
            // Http Error
            // Send the error to the server
            errorsService.log(error);
            // Show notification to the user

            //TODO: Handle Http Error (error.status === 403, 404...)

            return notificationService.notify(`${error.status} - ${error.message}`);
        } else {
            // Client Error Happend
            // Send the error to the server and then
            // redirect the user to the page with all the info
            notificationService.notify(`Error has occoured and has reportered to the server. Page might not work as expected.`);
            errorsService.log(error);
        }
    }

    ngOnDestroy(): void {
        this._utils.unsubscribe(this._subscriptions);
    }
}
